var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLookingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search_{icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IS-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "P-01Homepage-1440-PersonalLinesGETAQ",
    transform: "translate(-1022.000000, -157.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(525.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(114.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_{icon",
    transform: "translate(384.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38163185,7.41679304 C8.04636436,9.8338286 5.00306115,10.7108104 2.58443596,9.37593545 C0.166296153,8.0410605 -0.711262413,4.99975747 0.624490449,2.58320696 C1.95975794,0.166171402 5.00306115,-0.710810396 7.42120096,0.624064553 C8.99575848,1.49280039 9.9174862,3.08475518 10,4.75722932",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,8.5 L10,10",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7477554,15.5580046 L15.5579956,15.7477605 C15.2211842,16.0840798 14.6698617,16.0840798 14.3330502,15.7477605 L10.2529726,11.66728 C9.91567581,11.3304754 9.91567581,10.7791641 10.2529726,10.4423594 L10.442247,10.2526035 C10.7795438,9.91579884 11.330381,9.91579884 11.6676777,10.2526035 L15.7477554,14.3330839 C16.0840815,14.6698886 16.0840815,15.2211999 15.7477554,15.5580046 Z",
    id: "Stroke-5"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookingGlass);
export default __webpack_public_path__ + "static/media/looking-glass.231ef038810a87217e4ca46aa9ba06c0.svg";
export { ForwardRef as ReactComponent };